export default __webpack_public_path__ + "static/media/funding grey 1.905d7ee7.svg";